/** Reversible presentation switch; private endpoints have their own server switch. */
export function isUniversalSearchEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_UNIVERSAL_SEARCH === 'true'
}
